export default __webpack_public_path__ + "static/media/add.09885980.svg";